import { render, staticRenderFns } from "./contract_approve_pc.vue?vue&type=template&id=5f157a04&scoped=true&"
import script from "./contract_approve_pc.vue?vue&type=script&lang=js&"
export * from "./contract_approve_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f157a04",
  null
  
)

export default component.exports